<template>
    <div class="main">
      <div class="detailContent">
        <el-form
          label-position="left"
          ref="formGenericContent"
          :model="formGenericContent"
          :rules="formGenericContentRules"
        >
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Field" prop="field">
                <el-input
                  v-model="formGenericContent.field"
                  placeholder="Please enter"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Type" prop="type">
                <el-input
                  v-model="formGenericContent.type"
                  placeholder="Please enter"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row type="flex" justify="end" :gutter="20">
            <el-col :span="2">
              <el-button style="width: 100%" size="small" @click="centerDialogVisible = true">Preview</el-button>
            </el-col>
            <el-col :span="2">
              <el-button style="width: 100%" size="small" @click="handleValidate">Validate</el-button>
            </el-col>
            <el-dialog
              :visible.sync="centerDialogVisible"
              width="75%"
              center>
              <div v-html="getContent(this.contentLang)"></div> 
              <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">Close</el-button>
              </span>
            </el-dialog>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="50">
            <el-col :span="24">
              <el-form-item prop="contentEn">
                <el-tabs type="border-card" class="demo-tabs" @tab-click="setContentLang">
                    <el-tab-pane label="Content (EN)" label-width="10px" >
                      <el-input
                        v-model="formGenericContent.contentEn"
                        placeholder="Please enter"
                        type="textarea"
                        resize="none"
                        :autosize="{ minRows: 25, maxRows: 25 }"
                        ></el-input>
                    </el-tab-pane>
                    <el-tab-pane label="Content (JP)">
                      <el-input
                        v-model="formGenericContent.contentJa"
                        placeholder="Please enter"
                        type="textarea"
                        resize="none"
                        :autosize="{ minRows: 25, maxRows: 25 }"
                        ></el-input>
                    </el-tab-pane>
                    <el-tab-pane label="Content (TC)">
                      <el-input
                        v-model="formGenericContent.contentTc"
                        placeholder="Please enter"
                        type="textarea"
                        resize="none"
                        :autosize="{ minRows: 25, maxRows: 25 }"
                        ></el-input>
                    </el-tab-pane>
                    <el-tab-pane label="Content (SC)">
                      <el-input
                        v-model="formGenericContent.contentSc"
                        placeholder="Please enter"
                        type="textarea"
                        resize="none"
                        :autosize="{ minRows: 25, maxRows: 25 }"
                        ></el-input>
                    </el-tab-pane>
                </el-tabs>
              </el-form-item>
            </el-col>
            
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
        <el-col :span="4">
          <el-button v-if="showSave" class="reset" style="width: 100%" @click="handleCancel"
            >Cancel</el-button
          >
        </el-col>
        <el-col :span="4">
          <el-button
            v-if="showSave"
            type="primary"
            style="width: 100%"
            @click=""
            >Create</el-button
          >
        </el-col>
      </el-row> -->
    </div>
  </template>
  
  <script>
  import { contentDetail } from '../../../request/api';
  export default {
    name: "createOfficeLocation",
    data() {
      return {
        formGenericContentRules: this.$validation.genericContentCreate,
        formGenericContent: {
          contentEn: "",
          contentTc: "",
          contentSc: "",
          contentJa: "",
          field: "",
          type: "",
        },
        centerDialogVisible: false,
        showSave: true,
        contentLang: 'EN'
      };
    },
    props:{
      id: String,
      validate: Boolean
    },
    methods: {
      handleCancel() {
        this.$router.push("/officeLocations");
      },
      setContentLang(tab, event){
        switch(tab.label){
          case "Content (TC)":
            this.contentLang = 'TC';
            break;
          case "Content (SC)":
            this.contentLang = 'SC';
            break;
          case "Content (JP)":
            this.contentLang = 'JA';
            break;
          default:
            this.contentLang = 'EN';
            break;
        }
      },
      showBtn(val) {
        var permissions = this.$store.state.permissions.filter(
          (item) => item == val
        );
        if (!permissions[0]) {
          this.showSave = false;
        }
      },
      handleValidate(){
        this.$refs.formGenericContent.validate((valid) => {
          this.$emit('getIsValid', valid)
        })
      },
      getDetail(){
        contentDetail(this.id).then(res => {
            let detail = res.data.payload;
            this.formGenericContent.id = detail.id
            this.formGenericContent.field = detail.field
            this.formGenericContent.type = detail.type
            this.formGenericContent.contentEn = detail.contentEN
            this.formGenericContent.contentJa = detail.contentJA
            this.formGenericContent.contentSc = detail.contentSC
            this.formGenericContent.contentTc = detail.contentTC
        })
      },
      getContent(lang) {
        switch(lang){
          case "TC":
            return this.formGenericContent.contentTc;
          case "SC":
            return this.formGenericContent.contentSc;
          case "JA":
            return this.formGenericContent.contentJa;
          default:
            return this.formGenericContent.contentEn;
        }
      }
    },
    created: function () {
      this.showBtn("CONTENT_WRITE");
      this.$emit('setFormValue',this.formGenericContent)
      
      if(this.id > 0){
        this.getDetail();
      }
      // let isValid = false;
    },
    watch:{
      validate: function(newVal, oldVal){
        this.handleValidate()
      }
    }
  };
  </script>
  
  <style scoped>
  </style>


// WEBPACK FOOTER //
// src/components/content/genericContent/genericContentForm.vue